export = {
  kt_aws_src_acc_id: 'AWS Account',
  kt_aws_src_acc_alias: 'AWS Account Alias',
  kt_aws_src_acc_name: 'AWS Account Name',
  kt_aws_src_vm_name: 'AWS Instance Name',
  kt_aws_src_vm_id: 'AWS Instance',
  kt_aws_src_region: 'AWS Region',
  kt_aws_src_zone: 'AWS Zone Name',
  kt_aws_src_zone_id: 'AWS Zone ID',
  kt_aws_src_vm_type: 'AWS Instance Type',
  kt_aws_src_image_id: 'AWS Image ID',
  kt_aws_src_sg: 'AWS Security Group',
  kt_aws_src_asg: 'AWS Auto Scaling Group',
  kt_aws_src_pub_dns: 'AWS Public DNS Name',
  kt_aws_src_priv_dns: 'AWS Private DNS Name',
  kt_aws_src_vpc_id: 'AWS VPC ID',
  kt_aws_src_vpc_name: 'AWS VPC Name',
  kt_aws_src_subnet_id: 'AWS Subnet ID',
  kt_aws_src_subnet_name: 'AWS Subnet Name',
  kt_aws_src_vm_tags: 'AWS Instance Tags',
  kt_aws_dst_acc_id: 'AWS Account',
  kt_aws_dst_acc_alias: 'AWS Account Alias',
  kt_aws_dst_acc_name: 'AWS Account Name',
  kt_aws_dst_vm_name: 'AWS Instance Name',
  kt_aws_dst_vm_id: 'AWS Instance',
  kt_aws_dst_region: 'AWS Region',
  kt_aws_dst_zone: 'AWS Zone Name',
  kt_aws_dst_zone_id: 'AWS Zone ID',
  kt_aws_dst_vm_type: 'AWS Instance Type',
  kt_aws_dst_image_id: 'AWS Image ID',
  kt_aws_dst_sg: 'AWS Security Group',
  kt_aws_dst_asg: 'AWS Auto Scaling Group',
  kt_aws_dst_pub_dns: 'AWS Public DNS Name',
  kt_aws_dst_priv_dns: 'AWS Private DNS Name',
  kt_aws_dst_vpc_id: 'AWS VPC ID',
  kt_aws_dst_vpc_name: 'AWS VPC Name',
  kt_aws_dst_subnet_id: 'AWS Subnet ID',
  kt_aws_dst_subnet_name: 'AWS Subnet Name',
  kt_aws_dst_vm_tags: 'AWS Instance Tags',
  kt_aws_action: 'AWS Firewall Action',
  kt_aws_status: 'AWS Logging Status',
  kt_az_src_inst_name: 'Azure Instance Name',
  kt_az_src_inst_id: 'Azure Instance',
  kt_az_src_region: 'Azure Region',
  kt_az_src_zone: 'Azure Zone',
  kt_az_src_inst_type: 'Azure Instance Type',
  kt_az_src_fqdn: 'Azure Public DNS Name',
  kt_az_src_vnet: 'Azure VNet ID',
  kt_az_src_subnet: 'Azure Subnet Name',
  kt_az_src_rsrc_group: 'Azure Resource Group',
  kt_az_src_public_ip: 'Azure Public IP Address',
  kt_az_src_sub_id: 'Azure Subscription',
  kt_az_src_sub_name: 'Azure Subscription Name',
  kt_az_dst_inst_name: 'Azure Instance Name',
  kt_az_dst_inst_id: 'Azure Instance',
  kt_az_dst_region: 'Azure Region',
  kt_az_dst_zone: 'Azure Zone',
  kt_az_dst_inst_type: 'Azure Instance Type',
  kt_az_dst_fqdn: 'Azure Public DNS Name',
  kt_az_dst_vnet: 'Azure VNet ID',
  kt_az_dst_subnet: 'Azure Subnet Name',
  kt_az_dst_rsrc_group: 'Azure Resource Group',
  kt_az_dst_public_ip: 'Azure Public IP Address',
  kt_az_dst_sub_id: 'Azure Subscription',
  kt_az_dst_sub_name: 'Azure Subscription Name',
  kt_k8s_src_pod_name: 'Source Pod Name',
  kt_k8s_src_pod_ns: 'Source Pod Namespace',
  kt_k8s_src_load_name: 'Source Workload Name',
  kt_k8s_src_load_ns: 'Source Workload Namespace',
  kt_k8s_dst_pod_name: 'Destination Pod Name',
  kt_k8s_dst_pod_ns: 'Destination Pod Namespace',
  kt_k8s_dst_load_name: 'Destination Workload Name',
  kt_k8s_dst_load_ns: 'Destination Workload Namespace',
  kt_k8s_dst_cont_name: 'Destination Container Name',
  kt_k8s_src_svc_name: 'Source Service Name',
  kt_k8s_src_svc_ns: 'Source Service Namespace',
  kt_k8s_dst_svc_name: 'Destination Service Name',
  kt_k8s_dst_svc_ns: 'Destination Service Namespace',
  kt_src_site_title: 'Source Site by IP',
  kt_dst_site_title: 'Destination Site by IP',
  kt_src_site_type: 'Source Site Type by IP',
  kt_dst_site_type: 'Destination Site Type by IP',
  // aws subtypes
  ktsubtype__aws_subnet__INET_00: 'AWS Packet Address',
  ktsubtype__aws_subnet__INET_01: 'AWS Packet Address',
  ktsubtype__aws_subnet__INT00: 'AWS Start Time',
  ktsubtype__aws_subnet__INT01: 'AWS End Time',
  ktsubtype__aws_subnet__INT02: 'AWS Interface Type',
  ktsubtype__aws_subnet__INT03: 'AWS Interface Type',
  ktsubtype__aws_subnet__INT04: 'AWS Service',
  ktsubtype__aws_subnet__INT05: 'AWS Service',
  ktsubtype__aws_subnet__INT06: 'AWS Flow Direction',
  ktsubtype__aws_subnet__INT07: 'AWS Traffic Path',
  ktsubtype__aws_subnet__INT08: 'AWS ENI Entity Type',
  ktsubtype__aws_subnet__INT09: 'AWS ENI Entity Type',
  ktsubtype__aws_subnet__INT64_00: 'AWS Flow Log Account ID',
  ktsubtype__aws_subnet__STR03: 'AWS Observing Interface ID',
  ktsubtype__aws_subnet__STR04: 'AWS Forwarding State',
  ktsubtype__aws_subnet__STR09: 'AWS Interface ID',
  ktsubtype__aws_subnet__STR10: 'AWS Observing VPC ID',
  ktsubtype__aws_subnet__STR11: 'AWS Observing Subnet ID',
  ktsubtype__aws_subnet__STR12: 'AWS Observing Instance ID',
  ktsubtype__aws_subnet__STR14: 'AWS Observing Region',
  ktsubtype__aws_subnet__STR15: 'AWS Observing Availability Zone ID',
  ktsubtype__aws_subnet__STR16: 'AWS Observing Sublocation ID',
  ktsubtype__aws_subnet__STR17: 'AWS Gateway ID',
  ktsubtype__aws_subnet__STR19: 'AWS Gateway Type',
  ktsubtype__aws_subnet__STR20: 'AWS Interface ID',
  ktsubtype__aws_subnet__STR21: 'AWS ENI Description',
  ktsubtype__aws_subnet__STR22: 'AWS ENI Description',
  ktsubtype__aws_subnet__STR23: 'AWS ENI Entity Name',
  ktsubtype__aws_subnet__STR24: 'AWS ENI Entity Name',
  ktsubtype__aws_subnet__STR25: 'AWS Cloud Ultimate Exit',
  ktsubtype__aws_subnet__STR26: 'AWS Cloud Ultimate Exit Type',
  // azure subtypes
  ktsubtype__azure_subnet__STR00: 'Azure Security Rule',
  ktsubtype__azure_subnet__STR01: 'Azure Security Rule',
  ktsubtype__azure_subnet__STR02: 'Azure Firewall Action',
  ktsubtype__azure_subnet__STR03: 'Azure Firewall Action',
  ktsubtype__azure_subnet__STR04: 'Azure Security Group',
  ktsubtype__azure_subnet__STR05: 'Azure Security Group',
  ktsubtype__azure_subnet__STR06: 'Azure Interface Name',
  ktsubtype__azure_subnet__STR07: 'Azure Interface Name',
  ktsubtype__azure_subnet__STR08: 'Azure Observing MAC Address',
  ktsubtype__azure_subnet__STR09: 'Azure Gateway Name',
  ktsubtype__azure_subnet__STR10: 'Azure Gateway Name',
  ktsubtype__azure_subnet__STR11: 'Azure Gateway Type',
  ktsubtype__azure_subnet__STR12: 'Azure Gateway Type',
  ktsubtype__azure_subnet__STR13: 'Azure Ingress Virtual Hub',
  ktsubtype__azure_subnet__STR14: 'Azure Egress Virtual Hub',
  ktsubtype__azure_subnet__STR15: 'Azure ExpressRoute Circuit Name',
  ktsubtype__azure_subnet__STR16: 'Azure ExpressRoute Peering Type',
  ktsubtype__azure_subnet__STR17: 'Azure Logging Resource Category',
  ktsubtype__azure_subnet__STR18: 'Azure Logging Resource Name',
  ktsubtype__azure_subnet__STR19: 'Azure FQDN',
  ktsubtype__azure_subnet__STR20: 'Azure Firewall Policy',
  ktsubtype__azure_subnet__STR21: 'Azure Firewall Rule',
  ktsubtype__azure_subnet__STR22: 'Azure Application Protocol',
  ktsubtype__azure_subnet__STR23: 'Azure Load Balancer',
  ktsubtype__azure_subnet__STR24: 'Azure Load Balancer',
  // gcp subtypes
  ktsubtype__gcp_subnet__STR00: 'GCP Source Project ID',
  ktsubtype__gcp_subnet__STR01: 'GCP Destination Project ID',
  ktsubtype__gcp_subnet__STR02: 'GCP Source VM Name',
  ktsubtype__gcp_subnet__STR03: 'GCP Destination VM Name',
  ktsubtype__gcp_subnet__STR04: 'GCP Source Region',
  ktsubtype__gcp_subnet__STR05: 'GCP Destination Region',
  ktsubtype__gcp_subnet__STR06: 'GCP Source Zone',
  ktsubtype__gcp_subnet__STR07: 'GCP Destination Zone',
  ktsubtype__gcp_subnet__STR08: 'GCP Source Subnet Name',
  ktsubtype__gcp_subnet__STR09: 'GCP Destination Subnet Name',
  ktsubtype__gcp_subnet__STR10: 'GCP Reporter',
  ktsubtype__gcp_subnet__STR11: 'GCP VPC Name',
  ktsubtype__gcp_subnet__STR12: 'GCP VPC Name',
  ktsubtype__gcp_subnet__STR13: 'GCP GKE Pod Name',
  ktsubtype__gcp_subnet__STR14: 'GCP GKE Pod Name',
  ktsubtype__gcp_subnet__STR15: 'GCP GKE Pod Namespace',
  ktsubtype__gcp_subnet__STR16: 'GCP GKE Pod Namespace',
  ktsubtype__gcp_subnet__STR17: 'GCP GKE Cluster Name',
  ktsubtype__gcp_subnet__STR18: 'GCP GKE Cluster Name',
  ktsubtype__gcp_subnet__STR19: 'GCP GKE Cluster Location',
  ktsubtype__gcp_subnet__STR20: 'GCP GKE Cluster Location',
  ktsubtype__gcp_subnet__STR21: 'GCP GKE Service Name',
  ktsubtype__gcp_subnet__STR22: 'GCP GKE Service Name',
  ktsubtype__gcp_subnet__STR23: 'GCP GKE Service Namespace',
  ktsubtype__gcp_subnet__STR24: 'GCP GKE Service Namespace',
  ktsubtype__gcp_subnet__STR25: 'GCP Dedicated Interconnect Name',
  ktsubtype__gcp_subnet__STR26: 'GCP Dedicated Interconnect Type'
};
